export default {
  sm: `
  친환경 데이터센터의 기준
  `,
};
